/*!
 * Copyright (c) HSO.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export enum InputTypeExtension {
    // eslint-disable-next-line @typescript-eslint/no-shadow -- Text enum doesn't override the imported Text
    Text = 'text',
    Address = 'address',
    Email = 'email',
    TextArea = 'textarea',
    Checkbox = 'checkbox',
    Dropdown = 'dropdown'
};

export interface IBusinessSignUpExtensionInputProps {
    id?: string;
    type: InputTypeExtension;
    value?: string;
    pattern?: string;
    className: string;
    maxLength?: string;
    isRequired: boolean;
    onChange?(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>): void;
    fieldReference?: React.RefObject<HTMLInputElement>;
    placeholder?: string;
    stringList?: string[];
    highlightMissingFields?: boolean;
    isMissingFields?: boolean;
};

const GetMaxLength = (maxLength?: string): number | undefined => {
    if (maxLength) {
        const parsedMaxLength = Number.parseInt(maxLength, 10);
        if (!isNaN(parsedMaxLength)) {
            return parsedMaxLength;
        }
    }

    return undefined;
};

export const SignUpExtensionInput: React.FC<IBusinessSignUpExtensionInputProps> = ({
    id,
    type,
    value,
    pattern,
    className,
    maxLength,
    isRequired,
    onChange,
    fieldReference,
    placeholder,
    stringList,
    highlightMissingFields,
    isMissingFields
}) => {
    let requiredStyle: React.CSSProperties | undefined = (highlightMissingFields || isMissingFields) && isRequired && value === '' ? { borderColor: "red" } : undefined;
    if ((highlightMissingFields || isMissingFields) && isRequired && value && value !== '' && pattern !== undefined && value.match(pattern) === null) {
        requiredStyle = { borderColor: "red" };
    }

    if (requiredStyle != undefined && type === InputTypeExtension.Checkbox) {
        requiredStyle = { color: "red" };
    }

    if (type === InputTypeExtension.TextArea) {
        return (
            <textarea
                id={id}
                name={id}
                value={value}
                className={`${className}-input-area ${className}-${id}`}
                aria-required={isRequired}
                maxLength={GetMaxLength(maxLength)}
                onChange={onChange}
                placeholder={placeholder}
                required={isRequired}
                style={requiredStyle}
            />
        );
    }

    if (type === InputTypeExtension.Dropdown) {
        return (
            <select name={id} id={id} className={`${className}-input ${className}-${id}`} aria-required={isRequired} onChange={onChange} required={isRequired} style={requiredStyle}>
                <option hidden disabled selected value=''></option>
                {stringList &&
                    stringList.map((item: string) => {
                        return (
                            <option key={id} value={item}>
                                {item}
                            </option>
                        );
                    })}
            </select>
        );
    }

    if (type === InputTypeExtension.Checkbox) {
        return (
            <div className='marginTopBottom-20'>
                {stringList &&
                    stringList.map((item: string) => {
                        let itemId = `${id}-${item}`
                        return (
                            <>
                                <input id={itemId} type='radio' name={id} value={item} aria-required={isRequired} onChange={onChange} ref={fieldReference} required={isRequired} />
                                <label id={`${itemId}_label`} className='radio_label' htmlFor={itemId} style={requiredStyle}>
                                    {item}
                                </label>
                            </>
                        );
                    })}
            </div>
        );
    }

    return (
        <input
            id={id}
            type={type}
            value={value}
            className={`${className}-input ${className}-${id}`}
            pattern={pattern !== '' ? pattern : undefined}
            aria-required={isRequired}
            maxLength={GetMaxLength(maxLength)}
            onChange={onChange}
            ref={fieldReference}
            placeholder={placeholder}
            required={isRequired}
            style={requiredStyle}
        />
    );
};

export default SignUpExtensionInput;
